<template>
    <div class="row">
      <div class="col-sm-6">
        <DoughnutChart
          v-bind:chartLabels = "this.chartLabels"
          v-bind:dataValues = "this.dataValues">
        </DoughnutChart>
      </div>
      <div class="col-sm-6">
        <ChartKey
          v-bind:chartLabels = "this.chartLabels"
          v-bind:dataValues = "this.dataValues">
        </ChartKey>
      </div>
    </div>
</template>

<script>
  import DoughnutChart from './DoughnutChart.vue';
  import ChartKey from './ChartKey.vue';

  export default {
    components: {
      DoughnutChart,
      ChartKey
    },
     props: {
      chartLabels: Array,
      dataValues: Array
    }
  }
</script>